<template>
  <div v-if="isReadyToDraw">
    <div class="ticket-romancecar mb-inquiry">
      <!-- ヘッダー -->
      <MFITTHeader :headerTitle="
        ticketStatus == 'reserved' ? '予約変更' : 'チケット内容変更'
      " :clickBackButtonEvent="backToMyTicketPage" />
      <br />

      <section class="form">
        <!-- 日時選択 -->
        <MFITTBookingSelectDate v-model:dateRadio="dateRadio" v-model:selectedDate="selectedDate"
          v-model:selectedTime="selectedTime" :isValidDate="isValidDate" />
      </section>

      <div class="content-block">
        <div class="block">
          <!-- 区間 -->
          <MFITTFromStation :stationName="myLimitedExpressTicket.from_station.name" />
          <MFITTToStation :stationName="myLimitedExpressTicket.to_station.name" />

          <!-- 人数 -->
          <StorePassenger :adult="myLimitedExpressTicket.adult_count" :child="myLimitedExpressTicket.child_count"
            :isSaloon="myLimitedExpressTicket.saloon_count > 0" />
        </div>
      </div>

      <!-- 購入チケットの変更の場合は、注意書き表示 -->
      <!-- 引換えの場合もticketStatusは購入と同じなので注意 -->
      <MFITTPurchasedTicketChangeCaution v-if="ticketStatus == 'purchased' && !isUseCoupon" />

      <!-- 引換券使用時は特付FPの場合のみ注意書き表示 -->
      <MFITTExchangedTicketChangeCaution v-else-if="ticketStatus == 'purchased' && isExchange" />
    </div>

    <MFITTBookingBottomButton :isReservedChange="ticketStatus == 'reserved'"
      :isPurchasedChange="ticketStatus == 'purchased'" :isSaloon="myLimitedExpressTicket.saloon_count > 0"
      :beforeBoardingDate="myLimitedExpressTicket.boarding_date"
      :hasChangedBoardingDate="myLimitedExpressTicket.is_change_boarding_date" :boardingDate="selectedDate"
      :searchDivision="dateRadio" :time="selectedTime" :fromStation="myLimitedExpressTicket.from_station"
      :toStation="myLimitedExpressTicket.to_station" :adultCount="myLimitedExpressTicket.adult_count"
      :childCount="myLimitedExpressTicket.child_count" :isCompleteInput="isCompleteInput" />
  </div>
</template>

<script>
import { computed, watchEffect, ref } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";

import mfittService from "@/services/MFITT";
import moment from "@/services/moment";
import commonMethodsMixin from "@/mixins/Common/CommonMethodsMixin";

export default {
  name: "TemplateMfittMyTicketChange",
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();

    const isReadyToDraw = ref(false);
    const myLimitedExpressTicket = computed(
      () => store.getters["MFITT/myLimitedExpressTicket"]
    );
    const ticketStatus = route.query.ticketStatus;
    const selectedCoupon = store.getters["MFITT/selectedCoupon"];
    const isUseCoupon = selectedCoupon != null;
    const isExchange = isUseCoupon && selectedCoupon.type == "exchange"; // 特付FP

    // 日付選択
    const dateRadio = ref(3);
    const selectedDate = ref(moment(new Date()).format("YYYY-MM-DD"));
    const selectedTime = ref("");

    // 有効な日付、時間が選択されているか？
    // local(Chrome), AndroidだとカレンダーUIで選択日付をブロックできるが、iOSはできないのでこのチェックが必要
    const isValidDate = computed(() => {
      if (isUseCoupon) {
        return mfittService.hasSelectedValidDateWithCoupon(
          selectedCoupon,
          selectedDate.value
        );
      } else {
        return mfittService.checkIsFromTodayUntilOneMonth(selectedDate.value);
      }
    });

    const isSelectedTime = computed(() => selectedTime.value != "");

    // 必要な情報が全て入力されているか？
    const isCompleteInput = computed(
      () => isValidDate.value && isSelectedTime.value
    );

    // headerのbackButton用の処理。
    // 条件に合う座席がないエラーで画面遷移してきた場合等にうまく動作しないので、明示的にMyTicketを指定して戻る
    const backToMyTicketPage = () => {
      router.push({
        name: "MfittMyTicket",
        params: { id: route.params.id },
        query: isUseCoupon ? { is_used_coupon: true } : {},
      });
    };

    watchEffect(() => {
      if (myLimitedExpressTicket.value != null) {
        selectedDate.value = moment(
          myLimitedExpressTicket.value.boarding_date
        ).format("YYYY-MM-DD");
        selectedTime.value = commonMethodsMixin.methods.displayMfittTime(
          myLimitedExpressTicket.value.departure_at
        );
        isReadyToDraw.value = true;
      }
    });

    return {
      isReadyToDraw,
      isUseCoupon,
      isExchange,
      myLimitedExpressTicket,
      dateRadio,
      selectedDate,
      selectedTime,
      isValidDate,
      isCompleteInput,
      ticketStatus,
      backToMyTicketPage,
    };
  },
};
</script>
